import { render, staticRenderFns } from "./NewVersionAvailable.vue?vue&type=template&id=0aa1cd98&scoped=true"
import script from "./NewVersionAvailable.vue?vue&type=script&lang=ts"
export * from "./NewVersionAvailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1cd98",
  null
  
)

export default component.exports